<template>
  <div class="pa-10">
    <v-alert color="error" type="error">
        <h3>غير مصرح لك بمشاهدة هذه الصفحة</h3>
        <b>لا تملك الصلاحيات الكافية للوصول الى هذه الصفحة</b>
    </v-alert>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>